import { motion, useReducedMotion } from 'framer-motion';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export const Reveal = ({ children, className = '', delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div initial={reduced ? false : { opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.8, delay, ease: [0.2, 0.7, 0.2, 1] }} className={className} {...props}>{children}</motion.div>;
};
export const Chapter = ({ number, label, dark = false }) => <div data-testid={`chapter-${number}-label`} className={`chapter-label ${dark ? 'on-dark' : ''}`}><span>{number.padStart(2, '0')}</span><span>{label}</span><span className="chapter-line" /></div>;
export const Action = ({ children, arrow = 'diagonal', className = '', ...props }) => <Button className={`action ${className}`} {...props}>{children}{arrow === 'diagonal' ? <ArrowUpRight size={18} /> : arrow === 'right' ? <ArrowRight size={18} /> : null}</Button>;
export const Estimate = ({ id, children = 'Hipótese de trabalho' }) => <span data-testid={id} className="estimate-tag"><span />{children}</span>;

export const InnerTabs = ({ tabs, active, onChange, testid = 'inner-tabs' }) => (
  <div className="inner-tabs" data-testid={testid} role="tablist">
    {tabs.map(({ id, label, Icon, warn }) => {
      const selected = active === id;
      return (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={selected}
          data-testid={`${testid}-${id}`}
          className={`inner-tab-button ${selected ? 'selected' : ''} ${warn ? 'warn' : ''}`}
          onClick={() => onChange(id)}
        >
          {Icon && <Icon size={13} aria-hidden="true" />}
          <span>{label}</span>
        </button>
      );
    })}
  </div>
);